import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// API
import * as API from '../../utils/api';

// Components
import UserHeader from './Users/UserHeader';
import UserActions from './Users/UserActions';

class User extends Component {
   static propTypes = {
    userInfo: PropTypes.object
  }

  deleteUser = () => {
    API.deleteUser(this.props.currentUser, this.props.userInfo.id)
    .then(response => {
      response.success ? this.props.onDeleteClicked(this.props.userInfo.id) : console.log("Could not delete user")
    });
  }

  render() {
    const { userInfo } = this.props
    if (!userInfo) { return null }
    
    const {first_name,last_name, email} = userInfo
    return (
      <div className="admin-profile-card">
        <UserHeader first_name={first_name} last_name={last_name} email={email} />
        <UserActions deleteUser={this.deleteUser} />
      </div>
    )
  }
}

// Connect to Redux to get current user
const mapStateToProps = state => ({ currentUser: state.user })

export default connect(mapStateToProps)(User)



// WEBPACK FOOTER //
// ./src/components/Admin/User.js